import { LINKEDIN } from "./data";

export function Footer() {
  return (
    <footer className="footer page-width">
      <span>© {new Date().getFullYear()} Sandeep Sirodia</span>
      <a href={LINKEDIN} target="_blank" rel="noreferrer" data-testid="footer-linkedin-link">
        LinkedIn ↗
      </a>
      <span>Built for useful conversations.</span>
      <a href="#top" data-testid="footer-back-to-top">
        Back to top ↑
      </a>
    </footer>
  );
}
